import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/thornton-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-thornton-colorado",
      statusCode: 301,
    });
  },
});
